// extracted by mini-css-extract-plugin
export default {"adornment":"QbtrUFiRyGlVvfpsxsZ8","custom-autocomplete":"Zs9TOCrOyWV3745rhNXJ"};